import getApprovals from "./getApprovals.api";
import putApproval from "./putApproval.api";
import getListing from "./getApprovalListing.api";
import putWhiteLabel from "./putWhiteLabel.api";
import getCompanyUsers from "./getCompanyUsers.api";
import postCreditTransfer from "./postCreditTransfer.api";
import getAccessRights from "./getAccessRights.api";
import updateAccessRights from "./updateAccessRights.api";
import getAvailablePlans from "./getAvailablePlans.api";
import getCompanyPlanInfo from "./getCompanyPlanInfo.api";
import updateCompanyPlan from "./updateCompanyPlan.api";
import getApprovalAvailableAccessRight from "./getApprovalAvailableAccessRight.api";
import getNodesWithWhiteLabel from "./getNodesWithWhiteLabel.api";
import putBranchWhiteLabel from "./putBranchWhiteLabel.api";
import removeBranchWhiteLabel from "./removeBranchWhiteLabel.api";
import getBranchListByProduct from "./getBranchListByProduct.api";
import getProductList from "./getProductList.api";
import updateAssign from "./updateAssign.api";
import updateUnassign from "./updateUnassign.api";
import updateUnassignUrl from "./updateUnassignUrl.api";
import setCompanyStatus from "./setCompanyStatus.api";
import removeCompanyWhiteLabel from "./removeCompanyWhiteLabel.api";
import getNodeSnRange from "./getNodeSnRange.api";
import getSnFormatsByBranch from "./getSnFormatsByBranch.api";
import checkSnAssignAvailability from "./checkSnAssignAvailability.api";
import getReassignHistory from "./getReassignHistory.api";
import getReassignProgress from "./getReassignProgress.api";
import impersonate from "./impersonate.api";
import updateCompanyExpiredDate from "./updateCompanyExpiredDate.api";
import getCompanyExpiredDate from "./getCompanyExpiredDate.api";
import validateUnassignUrl from "./validateUnassignUrl.api";
import validateUnassignRange from "./validateUnassignRange.api";
import getPetworldJobs from "./getPetworldJobs.api";
import postReimbursedCredit from "./postReimbursedCredit.api";
import getBundleOptions from "./getBundleOptions.api";
import getCompanyBundle from "./getCompanyBundle.api";
import setCompanyBundle from "./setCompanyBundle.api";
import getCompanyTags from "./getCompanyTags.api";
import putCompanyTags from "./putCompanyTags.api";
import reassignNode from "./reassignNode.api";

const companiesApi = {
  getApprovals,
  putApproval,
  getListing,
  putWhiteLabel,
  removeCompanyWhiteLabel,
  getCompanyUsers,
  postCreditTransfer,
  getAccessRights,
  updateAccessRights,
  getAvailablePlans,
  getCompanyPlanInfo,
  updateCompanyPlan,
  getApprovalAvailableAccessRight,
  getNodesWithWhiteLabel,
  putBranchWhiteLabel,
  removeBranchWhiteLabel,
  getBranchListByProduct,
  getProductList,
  updateAssign,
  updateUnassign,
  updateUnassignUrl,
  setCompanyStatus,
  getNodeSnRange,
  getBundleOptions,
  getCompanyBundle,
  setCompanyBundle,
  getSnFormatsByBranch,
  checkSnAssignAvailability,
  getReassignHistory,
  getReassignProgress,
  impersonate,
  updateCompanyExpiredDate,
  getCompanyExpiredDate,
  validateUnassignUrl,
  validateUnassignRange,
  getPetworldJobs,
  postReimbursedCredit,
  getCompanyTags,
  putCompanyTags,
  reassignNode,
};

export default companiesApi;
